import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const QuickAssistIcon = ({ color = '#3F3F3F' }: Props) => (
  <Svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <Path
      d="M11 17L13 19C13.197 19.197 13.4308 19.3532 13.6882 19.4598C13.9456 19.5665 14.2214 19.6213 14.5 19.6213C14.7786 19.6213 15.0544 19.5665 15.3118 19.4598C15.5692 19.3532 15.803 19.197 16 19C16.197 18.803 16.3532 18.5692 16.4598 18.3118C16.5665 18.0544 16.6213 17.7786 16.6213 17.5C16.6213 17.2214 16.5665 16.9456 16.4598 16.6882C16.3532 16.4308 16.197 16.197 16 16"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.0002 14.0005L16.5002 16.5005C16.8981 16.8983 17.4376 17.1218 18.0002 17.1218C18.5628 17.1218 19.1024 16.8983 19.5002 16.5005C19.8981 16.1027 20.1215 15.5631 20.1215 15.0005C20.1215 14.4379 19.8981 13.8983 19.5002 13.5005L15.6202 9.6205C15.0577 9.0587 14.2952 8.74314 13.5002 8.74314C12.7052 8.74314 11.9427 9.0587 11.3802 9.6205L10.5002 10.5005C10.1024 10.8983 9.56284 11.1218 9.00023 11.1218C8.43762 11.1218 7.89805 10.8983 7.50023 10.5005C7.1024 10.1027 6.87891 9.56311 6.87891 9.0005C6.87891 8.43789 7.1024 7.89833 7.50023 7.5005L10.3102 4.6905C11.2225 3.78065 12.4121 3.20106 13.6909 3.04348C14.9696 2.8859 16.2644 3.15933 17.3702 3.8205L17.8402 4.1005C18.266 4.35749 18.7723 4.44662 19.2602 4.3505L21.0002 4.0005"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M21 3L22 14H20"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M3 3L2 14L8.5 20.5C8.89782 20.8978 9.43739 21.1213 10 21.1213C10.5626 21.1213 11.1022 20.8978 11.5 20.5C11.8978 20.1022 12.1213 19.5626 12.1213 19C12.1213 18.4374 11.8978 17.8978 11.5 17.5"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M3 4H11"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default QuickAssistIcon;
